import * as Sentry from "@sentry/react";
import React from "react";
import {
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType,
} from "react-router-dom";
import { APP_ENV, IS_DEVELOPMENT, SENTRY_DNS } from "@/constants/constants";
import { version as appVersion } from "../../../package.json";

/**
 * The only module that imports `@sentry/react`, so self-hosted builds can swap it
 * for ./self-hosted.ts and leave the SDK out of the bundle.
 */
const initSentry = ({ email }: { email: string }) => {
	if (IS_DEVELOPMENT) return;

	Sentry.init({
		integrations: [
			Sentry.reactRouterV6BrowserTracingIntegration({
				useEffect: React.useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes,
			}),
		],
		tracesSampleRate: 1.0,
		dsn: SENTRY_DNS,
		release: appVersion || "1.0.0",
		environment: APP_ENV,
	});

	Sentry.setUser({ email });
};

const { captureException } = Sentry;

export { captureException, initSentry };
